module.exports = __webpack_public_path__ + "img/ic_qrcode_linkin.618c46e.png";